export default {"src":"/uk/_next/static/media/tooltip.bb5036e6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};